let flyOptions = {
  "duration":   500,
  "delay":      0,
  "direction":  "top"
};



$w.onReady(function () {
	//TODO: write your page related code here...

});

export function text2_viewportEnter(event) {
$w("#section5").scrollTo();
$w("#vectorImage").hide("fly",flyOptions);
}


export function box2_viewportEnter(event) {
$w("#section1").scrollTo();
$w("#vectorImage").show("fly",flyOptions);
}